var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilemanagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.291,
    height: 25.436,
    viewBox: "0 0 25.291 25.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.89 -3.702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8,9.224a.271.271,0,0,0-.2-.051.252.252,0,0,0-.179.106l-4.975,6.629a.271.271,0,0,0,.217.433h8.29a.271.271,0,0,0,.271-.271A8.493,8.493,0,0,0,68.8,9.224ZM64.2,15.8,68.7,9.823A7.94,7.94,0,0,1,71.681,15.8Z",
    transform: "translate(-43.242 -3.746)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.361,28.938H18.538a.271.271,0,0,0,.095-.019.084.084,0,0,0,.027-.014.244.244,0,0,0,.054-.038l.024-.022a.387.387,0,0,0,.038-.054v-.027h0l1.89-5.243a10.269,10.269,0,0,0,5.82-9.246.271.271,0,0,0-.271-.271H16.775l5.663-7.545a.271.271,0,0,0-.054-.379,10.253,10.253,0,0,0-16.4,8.195,10.039,10.039,0,0,0,.108,1.46H4.361a.271.271,0,0,0-.271.271V28.668A.271.271,0,0,0,4.361,28.938ZM18.809,27.1V20.18h2.475ZM16.233,4.565a9.627,9.627,0,0,1,5.606,1.782l-5.822,7.767a.271.271,0,0,0,.217.433h9.709a9.717,9.717,0,0,1-5.007,8.222L21.923,20a.271.271,0,0,0-.255-.363h-2.86v-1.4a.271.271,0,0,0-.271-.271H10.167L9.211,15.9a.271.271,0,0,0-.246-.16H6.636a9.69,9.69,0,0,1,9.6-11.171ZM4.632,16.278H8.8l.951,2.074a.271.271,0,0,0,.246.157h8.268V28.4H4.632Z",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.457,64.57H12.911a.271.271,0,0,0-.271.271v1.9a.271.271,0,0,0,.271.271h9.546a.271.271,0,0,0,.271-.271v-1.9A.271.271,0,0,0,22.457,64.57Zm-.271,1.9h-9V65.112h9Z",
    transform: "translate(-6.235 -44.143)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilemanagement);
export default __webpack_public_path__ + "static/media/filemanagement.6d20bed6.svg";
export { ForwardRef as ReactComponent };